import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { API_BASE_URL } from '../config';

/**
 * [Öneri 3] Konumu olmayan kullanıcıyı il/ilçe eklemeye yönlendirir → bölgesel doğrulanmış fiyat kapsamı büyür.
 * Sessiz/kapatılabilir; hata/misafir durumunda hiç görünmez.
 */
const DISMISS_KEY = 'locationNudgeDismissed';

export default function LocationNudge() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(DISMISS_KEY) === '1') return;
    const authToken = localStorage.getItem('authToken');
    if (!authToken) return;
    let mounted = true;
    (async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/profile/location-status`, {
          credentials: 'include',
          headers: { Authorization: `Bearer ${authToken}` }
        });
        if (!res.ok) return;
        const data = await res.json();
        if (mounted && data?.ok && data.hasLocation === false) setShow(true);
      } catch (_) { /* sessiz */ }
    })();
    return () => { mounted = false; };
  }, []);

  if (!show) return null;

  return (
    <div className="mb-4 flex items-center gap-3 rounded-2xl border border-emerald-500/30 bg-emerald-500/10 px-4 py-3">
      <span className="material-symbols-outlined text-emerald-500">location_on</span>
      <div className="flex-1">
        <p className="text-sm font-bold text-emerald-700 dark:text-emerald-300">Konumunu ekle, mahalleline özel fiyatları gör</p>
        <p className="text-xs text-emerald-600/80 dark:text-emerald-400/80">
          İl/ilçeni eklersen, çevrendeki kullanıcılarca doğrulanmış gerçek fiyatları sepetinde görürsün.
        </p>
      </div>
      <Link
        to="/profile"
        className="shrink-0 rounded-lg bg-emerald-600 px-3 py-1.5 text-xs font-bold text-white hover:bg-emerald-700"
      >
        Ekle
      </Link>
      <button
        type="button"
        onClick={() => { localStorage.setItem(DISMISS_KEY, '1'); setShow(false); }}
        className="shrink-0 text-emerald-600/60 hover:text-emerald-700"
        aria-label="Kapat"
      >
        <span className="material-symbols-outlined text-lg">close</span>
      </button>
    </div>
  );
}
